import React, { useEffect, useState } from "react";
import type { TableProps } from "antd";
import { Space, Table } from "antd";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import moment from "moment";
import { getCommonState, getUserState } from "../../redux/store/getState";
import { filterAtcUser, getAtcUsers } from "../../redux/apiActions/userActions";

import studentId from "../../utils/studentId";
import { User } from "../../redux/apiSlice/userSlice";
import useSearch from "../../hooks/useSearch";
import ATCUserForm from "../../forms/ATCUserForm";
import { clearFilterValues } from "../../redux/apiSlice/commonSlice";
import { IconPrimary } from "../../components";
import { EditIcon } from "../../assets";
import useUser from "../../hooks/useUser";

type ColumnsType<T extends object = object> = TableProps<T>["columns"];

const ATCUserTable: React.FC = () => {
  const dispatch = useAppDispatch();
  const { usersAtc, loading } = useAppSelector(getUserState);
  const { filterFrom, filterTo } = useAppSelector(getCommonState);
  const { user } = useUser();
  const [data, setData] = useState<User[]>();
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });

  useSearch(usersAtc, setData);

  const isHaveEditPermission = user?.permissions?.includes("atc.edit");

  useEffect(() => {
    if (filterFrom && filterTo && user) {
      dispatch(
        filterAtcUser({
          queryParams: { from: filterFrom, to: filterTo },
          atc_id: user.atc.id,
        })
      );
    } else if (user) {
      dispatch(getAtcUsers(user.atc.id));
    }
  }, [filterFrom, filterTo, user, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(clearFilterValues());
    };
  }, [dispatch]);

  const columns: ColumnsType<User> = [
    {
      title: "Date and Time",
      dataIndex: "created_at",
      render: (created_at) =>
        `${moment(created_at).format("DD/MM/YYYY hh:mmA")}`,
    },
    {
      title: "Student ID",
      dataIndex: "id",
      render: (_, record) => <>{studentId(record)}</>,
    },

    {
      title: "Username",
      dataIndex: "username",
    },
    {
      title: "Email ID",
      dataIndex: "email",
    },
    {
      title: "Actions",
      render: (_, record) => (
        <Space>
          {isHaveEditPermission ? (
            <ATCUserForm record={record} />
          ) : (
            <IconPrimary disabled={true}>
              <EditIcon />
            </IconPrimary>
          )}
        </Space>
      ),
    },
  ];
  return (
    <Table
      style={{ marginTop: 20, whiteSpace: "pre" }}
      loading={loading.get}
      columns={columns}
      rowKey={(record) => record.id}
      dataSource={data}
      onChange={(p) =>
        setPagination({ current: p.current || 1, pageSize: p.pageSize || 10 })
      }
      pagination={pagination}
      rowClassName={(_, index) => (index % 2 === 0 ? "tr-light" : "tr-dark")}
    />
  );
};

export default ATCUserTable;
